import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { css } from "styled-components";
import { useThemeDefaults } from "../utils";
import Box from "../Box";
import Img from '../Img';

var arToPadding = function arToPadding(aspectRatio) {
  return "".concat(100 / aspectRatio, "%");
};

export var Container = useThemeDefaults(function (_ref) {
  var theme = _ref.theme,
      aspectRatio = _ref.aspectRatio;
  return {
    position: 'relative',
    width: '100%',
    paddingTop: arToPadding(aspectRatio || theme.proportional.aspectRatios["default"])
  };
}, Box);
export var Square = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    aspectRatio: theme.proportional.aspectRatios.square
  };
}, Container);
export var Wide = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    aspectRatio: theme.proportional.aspectRatios.wide
  };
}, Container);
export var Narrow = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    aspectRatio: theme.proportional.aspectRatios.narrow
  };
}, Container);
export var Containable = useThemeDefaults(function () {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 'inherit',
    height: '100%'
  };
}, Box);
export var Image = useThemeDefaults(function (_ref5) {
  var crop = _ref5.crop;
  return _objectSpread({
    as: Img
  }, crop ? {
    objectFit: 'cover'
  } : {});
}, Containable);
export var Artwork = useThemeDefaults(function (_ref6) {
  var theme = _ref6.theme;
  return {
    borderRadius: theme.proportional.artwork.borderRadius,
    border: theme.proportional.artwork.border,
    borderColor: theme.proportional.artwork.borderColor
  };
}, Image);